import Select from 'react-select';
import { selectStylesNoWrap } from '../bestek-filter/bestek-filter';
import { connect, useDispatch } from 'react-redux';
import { RootState } from '@/store';
import { useEffect } from 'react';
import apiService from '@/api-service';
import { SubwerkcatsState, subwerkcatActions } from '@/store/reducers/subwerkcats';
import { Subwerkcat } from '@/models/subwerkcat';
import { Werkcat } from '@/models/werkcat';

interface OwnProps {
    werkcats?: Werkcat[];
    selected: Subwerkcat[];
    onChange: (value: Subwerkcat[]) => void;
}

interface Props extends OwnProps {
    subwerkcat_state: SubwerkcatsState;
}

function mapStateToProps(state: RootState, ownProps: OwnProps): Props {
    return Object.assign({
        subwerkcat_state: state.subwerkcats
    }, ownProps);
}

function HoofdcodeSubwerkCategorieFilter(props: Props): JSX.Element {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!props.subwerkcat_state.loaded) {
            apiService.get<Subwerkcat[]>("/hoofdcode/subwerkcat")
                .then((res) => {
                    dispatch(subwerkcatActions.set_data(res.data.sort((a, b) => {
                        const wc = a.werk_categorie.werk_categorie.localeCompare(b.werk_categorie.werk_categorie);
    
                        return wc === 0 ? a.subwerk_categorie.localeCompare(b.subwerk_categorie) : wc;
                    })));
                }, console.error);
        }
    }, []);

    useEffect(() => {
        const selectedCatIDs = (props.werkcats ?? []).map(c => c.id);
        if (selectedCatIDs.length > 0 && props.selected.filter(s => !selectedCatIDs.includes(s.werk_categorie.id)).length > 0) {
            props.onChange(props.selected.filter(s => selectedCatIDs.includes(s.werk_categorie.id)));
        }
    });

    return (
        <>
            <label htmlFor="subwerkcat-select-box">Subwerkcategorie</label>
            <Select 
                styles={selectStylesNoWrap}
                inputId="subwerkcat-select-box" 
                options={props.subwerkcat_state.data.filter((s => (props.werkcats ?? []).length === 0 || (props.werkcats ?? []).map(c => c.id).includes(s.werk_categorie.id)))} 
                getOptionLabel={(o) => `${o.werk_categorie.werk_categorie}.${o.subwerk_categorie} - ${o.omschrijving}`} 
                getOptionValue={(o) => o.id.toString()} 
                onChange={v => props.onChange([ ... v ])}
                value={props.selected}
                isLoading={!props.subwerkcat_state.loaded} 
                isMulti isClearable />
        </>
    );
}

export default connect(mapStateToProps)(HoofdcodeSubwerkCategorieFilter);